import { getDbFromEvent, getSaleObjectStore } from "./indexedDbCrud.helper"

export const handleDeleteOfflineSalesSuccess = (event, commit) => {
  const objectStore = getSaleObjectStore(event, "readwrite", "sales")

  objectStore.clear()
  getDbFromEvent(event).close()
  commit("setOfflineSales", [])
}
